var _path, _path2, _mask, _rect, _mask2, _rect2, _rect3, _rect4, _path3, _rect5, _path4, _rect6, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21.6667L7.5 20.8333C7.5 19.9128 8.24619 19.1667 9.16667 19.1667L30.8333 19.1667C31.7538 19.1667 32.5 19.9128 32.5 20.8333L32.5 21.6667",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.8333V17.5",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667,
    strokeLinecap: "square"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_44981_9416",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 2.5,
    width: 15,
    height: 10.8333,
    rx: 0.833333
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 2.5,
    width: 15,
    height: 10.8333,
    rx: 0.833333,
    stroke: "currentColor",
    strokeWidth: 3.33333,
    mask: "url(#path-3-inside-1_44981_9416)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_44981_9416",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.6665,
    y: 11.6667,
    width: 6.66667,
    height: 4.16667,
    rx: 0.833333
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6665,
    y: 11.6667,
    width: 6.66667,
    height: 4.16667,
    rx: 0.833333,
    stroke: "currentColor",
    strokeWidth: 3.33333,
    mask: "url(#path-4-inside-2_44981_9416)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5832,
    y: 14.5833,
    width: 10.8333,
    height: 0.833333,
    rx: 0.416667,
    stroke: "currentColor",
    strokeWidth: 0.833333
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.83333,
    y: 24.1667,
    width: 3.33344,
    height: 4.16667,
    rx: 0.833333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 31.9298C3.33333 31.3713 3.65171 30.9128 4.10856 30.7473C5.11621 30.3822 6.4416 30 7.5 30C8.5584 30 9.88378 30.3822 10.8914 30.7473C11.3483 30.9128 11.6667 31.3713 11.6667 31.9298V35H3.33333V31.9298Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3333,
    y: 24.1667,
    width: 3.33344,
    height: 4.16667,
    rx: 0.833333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 31.9298C15.8333 31.3713 16.1517 30.9128 16.6086 30.7473C17.6162 30.3822 18.9416 30 20 30C21.0584 30 22.3838 30.3822 23.3914 30.7473C23.8483 30.9128 24.1667 31.3713 24.1667 31.9298V35H15.8333V31.9298Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8333,
    y: 24.1667,
    width: 3.33344,
    height: 4.16667,
    rx: 0.833333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 31.9298C28.3333 31.3713 28.6517 30.9128 29.1086 30.7473C30.1162 30.3822 31.4416 30 32.5 30C33.5584 30 34.8838 30.3822 35.8914 30.7473C36.3483 30.9128 36.6667 31.3713 36.6667 31.9298V35H28.3333V31.9298Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/CRM.554aa12b3de921a030f41bca207446f7.svg";
export { ForwardRef as ReactComponent };